var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({staticClass:"no-wrap",attrs:{"dense":"","outlined":"","hide-details":"","clearable":"","multiple":"","small-chips":"","deletable-chips":"","prepend-inner-icon":"fal fa-eye","menu-props":{
        bottom: true,
        offsetY: true,
    },"label":_vm.$t(`observation_labels['observation.visibility']`),"items":_vm.observationVisibility},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }